import { DiContainerInjectFn } from '@@/di/ts';
import { WarehousesService } from '@@/warehouses/services/warehouses.service';

export default ((container) => {
  container.bind(WarehousesService).to(WarehousesService).inSingletonScope();
}) as DiContainerInjectFn;
